import store from "@/store";
import { InspectKbn, SeibiKbn } from "@/model/InspectKbn";
import { InspectStaff } from "@/model/InspectStaff";
import { LiftUse } from "@/model/LiftUse";
import { InspectDetail } from "@/model/InspectDetail";
import { InspectionDetailState } from "@/store/modules/inspectionDetailStore";

const namespace = "InspectionDetail";

export class InspectionStaffKensainDetailStoreService {
  deSelKensain: boolean = false;

  // サービス初期化時に検査員の選択管理枠をStoreへ登録する
  constructor() {
    this.addNowSelected();
  }

  // InspectionDetail Store全体の現在状態を参照する
  get currentState(): InspectionDetailState {
    return store.getters[`${namespace}/currentState`];
  }

  // 検査員が選択済みかどうかを参照する
  get nowSelected(): boolean {
    const nowSelected = store.getters[`${namespace}/getNowSelected`];
    if (nowSelected.staffKensain === true || nowSelected.staffKensain === false) {
      return nowSelected.staffKensain;
    }
    this.addNowSelected();
    return false;
  }

  // 検査員一覧の選択済みデータを参照する
  get staffKensain(): InspectStaff[] {
    return store.getters[`${namespace}/getStaffKensain`];
  }

  // 検査員の選択管理枠をStoreへ追加する
  addNowSelected() {
    return store.dispatch(`${namespace}/addNowSelected`, "staffKensain");
  }

  // 検査員の選択済み状態をStoreへ反映する
  setNowSelected(payload: boolean) {
    return store.dispatch(`${namespace}/setNowSelected`, {
      key: "staffKensain",
      value: payload
    });
  }

  // 指定したスタッフ系リストの選択済み状態をStoreへ反映する
  setNowSelectedByKey(key: string, payload: boolean) {
    return store.dispatch(`${namespace}/setNowSelected`, {
      key,
      value: payload
    });
  }

  // 検査員の選択状態からスタート可否判定用の状態を更新する
  checkDisableStart(arrData: any, isUnSelect?: boolean) {
    let checked: boolean = false;
    if (isUnSelect) {
      checked = true;
    } else if (arrData) {
      checked = arrData.some((data: any) => data.selected == "1");
    }
    this.setNowSelected(checked);
  }

  // 補助整備士一覧をStoreへ反映する
  setStaffHojo(payload: InspectStaff[]) {
    return store.dispatch(`${namespace}/setStaffHojo`, payload);
  }

  // 検査員一覧をStoreへ反映する
  setStaffKensain(payload: InspectStaff[]) {
    return store.dispatch(`${namespace}/setStaffKensain`, payload);
  }

  // 整備士一覧をStoreへ反映する
  setStaffSeibishi(payload: InspectStaff[]) {
    return store.dispatch(`${namespace}/setStaffSeibishi`, payload);
  }

  // 共通処理から扱う検査員一覧を返す
  get list(): InspectStaff[] {
    return this.currentState.staffKensain;
  }

  // スタート時に保存対象にする検査員一覧を返す
  get selectedList(): InspectStaff[] {
    return this.staffKensain;
  }

  // 共通処理から検査員一覧をStoreへ反映する
  setList(payload: InspectStaff[]) {
    return this.setStaffKensain(payload);
  }

  // テンプレート表示用の検査員選択肢リストを生成する
  getTargetList() {
    return this.list.map((data: any) => {
      return {
        "mode": 1,
        "btnDel": false,
        "btnSel": data.selected == '1',
        "btnFre": data.selected == '0',
        "btnUse": data.inProgress == '1',
        "key": data.staffCd,
        "dataSet": data.staffCd,
        "isDisabled": false,
        "icon": "icon-engineer",
        "label": data.staffNm,
        "labelEntends1": null,
        "labelEntends2": null,
        "labelEntends3": null,
      };
    });
  }

  // スタート時に選択中の検査員を保存データへ反映する
  setStartInspectDetail(inspectionDetail: InspectDetail) {
    inspectionDetail.kensain = [];
    this.selectedList.filter((data: InspectStaff) => {
      if (data.selected == "1") {
        inspectionDetail.kensain.push({
          staffCd: data.staffCd,
          staffNm: data.staffNm
        });
      }
    });
  }

  // 取得済みの検査構成から検査員の初期選択情報を反映する
  applyInitialInspectionDetail(data: any, inspectionDetail?: InspectDetail) {
    // ダミー
    return { data, inspectionDetail };
  }

  // 検査員と同じスタッフが整備士・補助整備士で選択済みなら解除する
  unselectDupStaff(code: string) {
    const staffSeibishi = this.currentState.staffSeibishi;
    const dupSeibishi: any = staffSeibishi.find(data => data.staffCd == code && data.selected == "1");
    if (dupSeibishi) {
      dupSeibishi.selected = "0";
      this.setStaffSeibishi([...staffSeibishi]);
      this.setNowSelectedByKey("staffSeibishi", staffSeibishi.some((data: any) => data.selected == "1"));
    }

    const staffHojo = this.currentState.staffHojo;
    const dupHojo: any = staffHojo.find(data => data.staffCd == code && data.selected == "1");
    if (dupHojo) {
      dupHojo.selected = "0";
      this.setStaffHojo([...staffHojo]);
      this.setNowSelectedByKey("staffHojo", staffHojo.some((data: any) => data.selected == "1"));
    }
  }

  // 検査員の選択クリックを処理する
  select(code: string, confirm: boolean = false) {
    const staffKensain = this.list;
    let inprogressStaff: InspectStaff | null = null;
    staffKensain.map(data => {
      if (data.staffCd == code) {
        if (data.selected == "1") {
          data.selected = "0";
        } else {
          if (data.inProgress == 1 && !confirm) {
            inprogressStaff = data;
          }
          this.unselectDupStaff(code);
          staffKensain.map(data2 => (data2.selected = "0"));
          this.deSelKensain = false;
          data.selected = "1";
        }
      }
    });
    this.setList([...staffKensain]);
    this.checkDisableStart(staffKensain, this.deSelKensain);
    return { deSelKensain: this.deSelKensain, inprogressStaff };
  }

  // 検査員の「選択無し」状態を切り替える
  deSelect() {
    const staffKensain = this.list;
    if (!this.deSelKensain) {
      staffKensain.map(data => (data.selected = "0"));
    }
    this.deSelKensain = !this.deSelKensain;
    this.setList([...staffKensain]);
    this.checkDisableStart(staffKensain, this.deSelKensain);
    return this.deSelKensain;
  }

  // 検査員で「選択無し」を表示できるか返す
  canDeSelect() {
    return true;
  }

  // 検査員が「選択無し」状態か返す
  isDeSelected() {
    return this.deSelKensain;
  }

  // 共通呼び出し用の「選択無し」クリック処理
  clickDeSelect() {
    return this.deSelect();
  }

  // Storeに既存リストがある場合に選択状態を再評価する
  applyExistingList() {
    const staffKensain = this.list;
    if (this.selectedList.length == 0) {
      this.deSelKensain = true;
    }
    this.checkDisableStart(staffKensain, this.deSelKensain);
    return {
      staffKensain,
      deSelKensain: this.deSelKensain
    };
  }

  // API取得結果から検査員一覧の初期選択状態を作成する
  setInitialList(res: InspectStaff[], selectedStaff: any[] | undefined, isDeSelStaff: boolean) {
    const staffKensain = res.map(data => {
      let selected = "0";
      if (selectedStaff) {
        if (selectedStaff.findIndex(kensain => data.staffCd == kensain.staffCd) > -1) {
          selected = "1";
          this.setNowSelected(true);
        }
      }
      return { ...data, selected };
    });
    this.deSelKensain = false;
    if ((!selectedStaff || selectedStaff.length === 0) && isDeSelStaff) {
      this.setNowSelected(true);
      this.deSelKensain = true;
    }
    this.setList(staffKensain);
    return {
      staffKensain,
      deSelKensain: this.deSelKensain
    };
  }

  // 検査員一覧を既存StoreまたはAPIから取得する
  getDataList(
    loadInitialList: () => Promise<InspectStaff[]>,
    selectedStaff: any[] | undefined,
    isDeSelStaff: boolean
  ) {
    if (this.list.length > 0) {
      this.applyExistingList();
      return {
        hasExistingList: true,
        promise: null
      };
    }
    return {
      hasExistingList: false,
      promise: loadInitialList().then((res: InspectStaff[]) => {
        return this.setInitialList(res, selectedStaff, isDeSelStaff);
      })
    };
  }
}
